import styled from 'styled-components';

export const Line = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => props.theme.colors.lightGray};
  margin: 16px 0px 16px 0px;
`;
export const Value = styled.div`
  display: flex;
  margin-top: 5px;
  color: ${(props) => props.theme.colors.primary};
`;
export const Contract = styled.div`
  font-family: ${(props) => props.theme.primaryFont};
  font-size: 16px;
  line-height: 16px;
  color: #222222;
  height: 220px;
  overflow-y: auto;

  .description {
    word-wrap: break-word;
    margin-top: 4px;
    font-size: 12px;
    color: #7b86a3;
  }
`;

export const Infos = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.gray};
  font-size: 12px;
  justify-content: space-between;
`;
